import { Link } from 'react-router-dom';

import { useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import PromptDialog from '../../../Utilities/PromptDialog';
import RecurrenceModPopup from './RecurrenceModPopup';
import AlertDialog from '../../../Utilities/AlertDialog';
import { format } from 'date-fns';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import { useDispatch, useSelector } from 'react-redux';
import {
  handReSchedule,
  setAppPopup,
  setAppPrecurrencePopup,
  setGlobalAppId,
  setPatSrchDiasbled,
} from '../../../redux/slices/scheduler/appointmentSlice';
function FutureAppListRow({ data, reload }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const [canPromptDialog, setCanPromptDialog] = useState(false);
  const [delPromptDialog, setDelPromptDialog] = useState(false);
  const [noSoPromptDialog, setNoSoPromptDialog] = useState(false);
  const [sucPrams, setSucPrams] = useState({});
  const [handleRescheduledDialig, setHandleRescheduledDialig] = useState(false);
  const [recurrencePopup, setRecurrencePopup] = useState({
    status: false,
    data: null,
    flag: '',
  });
  const [noShowPrompt, setNoShowPrompt] = useState(false);

  const handleAppChange = (appId, data) => {
    if (parseInt(data?.recurring_id)) {
      setRecurrencePopup((preVal) => ({
        ...preVal,
        status: true,
        data: data,
        flag: 'change',
      }));
      dispatch(setPatSrchDiasbled(true));
    } else {
      dispatch(setAppPopup(true));
      dispatch(setGlobalAppId(appId));
      dispatch(setPatSrchDiasbled(true));
    }
  };

  const handleAppStatusAct = (flag, appId, appAutoId) => {
    if (flag === 'can') {
      if (parseInt(data?.recurring_id)) {
        setRecurrencePopup((preVal) => ({
          ...preVal,
          status: true,
          data: data,
          flag: 'can',
        }));
      } else {
        setCanPromptDialog(true);
      }
      setSucPrams({ appId, appAutoId });
    } else if (flag === 'del') {
      if (parseInt(data?.recurring_id)) {
        setRecurrencePopup((preVal) => ({
          ...preVal,
          status: true,
          data: data,
          flag: 'del',
        }));
      } else {
        setDelPromptDialog(true);
      }
      setSucPrams({ appId, appAutoId });
    } else if (flag === 'noso') {
      if (
        format(new Date(data?.start_time), DEFAULT_DATE_FORMATE) >
        format(new Date(), DEFAULT_DATE_FORMATE)
      ) {
        setNoShowPrompt(true);
      } else {
        setNoSoPromptDialog(true);
      }
      setSucPrams({ appId, appAutoId });
    } else if (flag === 'resch') {
      setHandleRescheduledDialig(true);
      setSucPrams({ appId, appAutoId });
    }
  };

  const handleRecAppStatusAct = (val, data, flag) => {
    const { appId, recurring_id: recurringId } = data;
    if (flag === 'can') {
      setCanPromptDialog(true);
    } else if (flag === 'del') {
      setDelPromptDialog(true);
    } else if (flag === 'change') {
      dispatch(setAppPopup(true));
      dispatch(setGlobalAppId(appId));
      dispatch(
        setAppPrecurrencePopup({
          status: true,
          type: val,
          recurringId: recurringId,
        }),
      );
    }

    setRecurrencePopup({ ...recurrencePopup, status: false });
    setSucPrams({ ...sucPrams, recurringVal: val });
  };

  const handleCancleAppConfirm = async (params) => {
    const { appId, appAutoId, recurringVal, promptVal, chkBoxVal } = params;
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: 2,
          currentStatusAutoIncId: appAutoId,
          patient_id: 0,
          loginUserId: user?.id,
          recurringVal: recurringVal || '0',
          reason: promptVal,
          is_no_show_billed: chkBoxVal,
        },
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Appointment canceled successfully.');
        setCanPromptDialog(false);
        reload();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleRescheduleConfirm = (params) => {
    setHandleRescheduledDialig(false);
    const { appId, appAutoId, promptVal, chkBoxVal } = params;
    dispatch(setAppPopup(true));
    dispatch(setGlobalAppId(appId));
    dispatch(
      handReSchedule({
        status: true,
        text: promptVal,
        appStatusAutoId: appAutoId,
        is_no_show_billed: chkBoxVal,
      }),
    );
  };

  const handleNoShowAppConfirm = async (params) => {
    const { appId, appAutoId, chkBoxVal, promptVal } = params;
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: 1,
          currentStatusAutoIncId: appAutoId,
          patient_id: 0,
          loginUserId: user?.id,
          recurringVal: 0,
          reason: promptVal,
          is_no_show_billed: chkBoxVal,
        },
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Appointment no show successfully.');
        setNoSoPromptDialog(false);
        reload();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleDeleteAppConfirm = async (params) => {
    const { appId, appAutoId, recurringVal, promptVal } = params;
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: 10,
          currentStatusAutoIncId: appAutoId,
          patient_id: 0,
          loginUserId: user?.id,
          recurringVal: recurringVal || '0',
          reason: promptVal,
        },
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Appointment delete successfully.');
        setDelPromptDialog(false);
        reload();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <>
      <span className="ahfh-lbl-2">
        {data.dov && format(new Date(data.dov), 'E, LLL d, yyyy')}
        {' at '}
        {data?.visitTime}
      </span>

      <span className="ahfh-lbl-1">
        <span className="" style={{ float: 'left' }}>
          {data?.tov}
        </span>
        &nbsp;
        {data?.telemedicine === '1' && (
          <span className="bold" style={{ fontSize: '10px' }}>
            &#128222;
          </span>
        )}
        {parseInt(data?.recurring_id) ? (
          <span
            className="recur-icon"
            title={`${data?.occurenceLeft} Occurrence left`}
          >
            ♽
          </span>
        ) : (
          ''
        )}
      </span>
      <span className="ahfh-lbl-4">
        {data?.provider}
        <br />
        {data?.resource}
      </span>
      {/* <span className="ahfh-lbl-3">
        <Link to="">Change</Link> | <Link to="">Cancel</Link> |{' '}
        <Link to="">Reschedule</Link> | <Link to="">Delete</Link>
      </span>
      <span className="pacolm1">
        <span dangerouslySetInnerHTML={{ __html: data.appDateTime }} />
      </span>
      <span className="pacolm5">{data.resourceName}</span>
      <span className="pacolm5">{data.supervisor}</span>
      <span className="pacolm4">{data.tovName}</span>
      <span className="pacolm4">
        <span dangerouslySetInnerHTML={{ __html: data.status }} />
      </span>
      <span className="pacolm1">{data.locationName}</span> */}
      <span className="pacolm4" style={{ lineHeight: '22px' }}>
        {parseInt(data?.appStatus) === 4 && (
          /*data?.start_date <= data?.current_date &&*/ <>
            <span
              className=""
              onClick={() => handleAppChange(data?.appId, data)}
            >
              <Link className="">Change</Link>
            </span>
            <span className="red"> | </span>
            <span
              className=""
              onClick={() =>
                handleAppStatusAct('can', data?.appId, data?.appStatusAutoId)
              }
            >
              <Link>Cancel</Link>
            </span>
            <span className="red"> | </span>
            {data?.recurring_id && parseInt(data?.recurring_id) === 0 && (
              <>
                <span
                  className=""
                  onClick={() =>
                    handleAppStatusAct(
                      'resch',
                      data?.appId,
                      data?.appStatusAutoId,
                    )
                  }
                >
                  <Link>Reschedule</Link>
                </span>
                <span className="red"> | </span>
              </>
            )}
            <span
              className=""
              onClick={() =>
                handleAppStatusAct('noso', data?.appId, data?.appStatusAutoId)
              }
            >
              <Link>No Show</Link>
            </span>
            <span className="red"> | </span>
            <span
              className=""
              onClick={() =>
                handleAppStatusAct('del', data?.appId, data?.appStatusAutoId)
              }
            >
              <Link>Delete</Link>
            </span>
          </>
        )}
      </span>

      {canPromptDialog && (
        <PromptDialog
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: `Cancel : ${data?.patientName} (${data.status})`,
              }}
            />
          }
          bodytext={`Do You really want to "Cancel" this appointment`}
          closeDialog={() => setCanPromptDialog(false)}
          successDialog={handleCancleAppConfirm}
          sucPrams={sucPrams}
          chkBoxShow={true}
          chkBoxText={`Bill this cancellation`}
        />
      )}
      {handleRescheduledDialig && (
        <PromptDialog
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: `Reschedule : ${data?.patientName} (${data.status})`,
              }}
            />
          }
          bodytext={`Do you really want to "Reschedule" this appointment`}
          closeDialog={() => setHandleRescheduledDialig(false)}
          successDialog={handleRescheduleConfirm}
          sucPrams={sucPrams}
          chkBoxShow={true}
          chkBoxText={`Bill this reschedule`}
        />
      )}
      {noSoPromptDialog && (
        <PromptDialog
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: `No Show : ${data?.patientName} (${data.status})`,
              }}
            />
          }
          bodytext={`Do you really want to "No Show" this appointment`}
          closeDialog={() => setNoSoPromptDialog(false)}
          successDialog={handleNoShowAppConfirm}
          sucPrams={sucPrams}
          chkBoxShow={true}
          chkBoxText={`Do not bill this No-Show`}
        />
      )}
      {delPromptDialog && (
        <PromptDialog
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: `Delete : ${data?.patientName} (${data.status})`,
              }}
            />
          }
          bodytext={`Do you really want to "Delete" this appointment`}
          closeDialog={() => setDelPromptDialog(false)}
          successDialog={handleDeleteAppConfirm}
          sucPrams={sucPrams}
        />
      )}
      {recurrencePopup?.status && (
        <RecurrenceModPopup
          handleClose={() =>
            setRecurrencePopup({ ...recurrencePopup, status: false })
          }
          data={recurrencePopup?.data}
          flag={recurrencePopup?.flag}
          callback={(val) =>
            handleRecAppStatusAct(
              val,
              recurrencePopup?.data,
              recurrencePopup?.flag,
            )
          }
        />
      )}
      {noShowPrompt && (
        <AlertDialog
          successDialog={() => setNoShowPrompt(false)}
          title={'Message'}
          bodytext={
            "You can't do the No-show process for this appointment because this is in future date"
          }
        />
      )}
    </>
  );
}

export default FutureAppListRow;
